import { Injectable } from "@angular/core";
import { CRBytesPrimeNGAdminConsoleLayoutPreferences, CRBytesPrimeNGAdminConsoleLayoutPreferenceStorageService, LOCAL_STORAGE_PREFERENCES_KEY } from "@cr-bytes/primeng-admin-console";

@Injectable({
    providedIn: 'root'
})
export class LayoutStorageService
    extends CRBytesPrimeNGAdminConsoleLayoutPreferenceStorageService
{
    override readPreferences(): CRBytesPrimeNGAdminConsoleLayoutPreferences
    {
        let prefsJson = localStorage.getItem(LOCAL_STORAGE_PREFERENCES_KEY);
        if ( prefsJson !== null )
        {
            const prefsObj = JSON.parse(prefsJson);
            return prefsObj;
        }

        // if no values stored yet, then provide a default value
        return {
            darkTheme: false,
            overlayMenu: false,
            menuActive: false
        }
    } // readPreferences
}
